import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from 'data/redux/actions'

export const useGameNews = (gameId) => {

  const dispatch = useDispatch()

  const game = useSelector(state => (state?.games || {})[gameId])

  useEffect(() => {

    if (!gameId) return
    refresh()

  }, [gameId])


  const refresh = () => {

    if (!gameId) return
    dispatch(actions.gameNewsLoad(gameId))
  }

  const getNew = newId => (game?.news || []).find(n => n.ID === newId)

  const parseContent = content => {

    const cleanContent = content.split('\n').join('')

    return window.playmotiv
                  .parser
                  .parseHtml(cleanContent)
  }

  return {
    news: game?.news || [],
    refresh,
    getNew,
    parseContent
  }
}
